import './../stylesheets/actiontext';
import './../stylesheets/crowd_fundings';

import * as kenAllComponent from './components/ken_all';
import * as currencyComponent from './components/currency';
import * as carouselComponent from './components/carousel';
import * as articleComponent from './components/article';
import * as municipalityComponent from './components/municipality';
import * as parentFieldComponent from './components/parent_field';
import * as fileFieldComponent from './components/file_field';
import * as searchComponent from './components/search';
import * as youtubeComponet from './components/youtube';
import * as formComponent from './components/form';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // 記事のアクション
  articleComponent.blockOldLink();
  // 住所のアクション
  kenAllComponent.setAdrresEvent();
  // 金額入力フィールドのアクション
  currencyComponent.displayYenField();
  currencyComponent.yenField();
  // メインカルーセル
  carouselComponent.syncingCarousel();
  // 開催地のアクション
  municipalityComponent.municipalityAllSelect();
  municipalityComponent.municipalityAllRelease();
  municipalityComponent.municipalityCustom();
  // 大分野のアクション
  parentFieldComponent.parentFieldAllSelect();
  parentFieldComponent.parentFieldAllRelease();
  parentFieldComponent.parentFieldCustom();
  // ファイルフィールドのアクション
  fileFieldComponent.selectFileFieldActions();
  fileFieldComponent.selectFileAfterActions();
  fileFieldComponent.cancelSelectFile();
  fileFieldComponent.destroySelectFile();
  // 詳細検索のアクション
  searchComponent.submitAction();
  searchComponent.ajaxSearchGroupResult();
  searchComponent.stopPagenationSubmitAction();
  // Youtubeのアクション
  youtubeComponet.playYoutubeOnModal();
  // フォームのアクション
  formComponent.temporarilySave();
})
